import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import styles from './ImportRecipientsStatus.style';
import { db } from '../../utilities/firebase-config';

const Recipient = ({ info }) => (
  <li>
    {info.recipient}
    {info.reason && <span>&nbsp; : &nbsp;</span>}
    {info.reason}
  </li>
);

Recipient.propTypes = {
  info: PropTypes.object.isRequired,
};

class ImportRecipientsStatus extends Component {
  state = {
    importStatus: null,
  };

  async componentDidMount() {
    const { importRecipientsKey } = this.props;

    if (importRecipientsKey) {
      db.ref(`importRecipientsStatus/${importRecipientsKey}`).on('value',
        (snapshot) => {
          const data = snapshot.val();

          this.setState({
            importStatus: data,
          });
        });
    }
  }

  componentWillUnmount() {
    const { importRecipientsKey } = this.props;
    db.ref(`importRecipientsStatus/${importRecipientsKey}`).off();
  }

  render() {
    const { importStatus } = this.state;
    const { classes, close } = this.props;

    if (!importStatus) {
      return null;
    }

    return (
      <Card className={ classes.card }>
        <CardContent>
          <Typography
            variant="h5"
            component="h2"
            className={ classes.title }
            gutterBottom
          >
            Number Import Status
          </Typography>
          { importStatus.imported
            && (
              <div>
                <Typography
                  variant="h6"
                  component="h3"
                  color="textSecondary"
                  className={ classes.title }
                >
                  Imported
                </Typography>
                {
                  importStatus.imported.map(recipient => (
                    <Recipient key={ recipient.recipient } info={ recipient } />
                  ))
                }
              </div>
            )
          }

          { importStatus.skipped
            && (
              <div>
                <Typography
                  variant="h6"
                  component="h3"
                  color="textSecondary"
                  className={ classes.title }
                >
                  Skipped
                </Typography>
                {
                  importStatus.skipped.map(recipient => (
                    <Recipient key={ recipient.recipient } info={ recipient } />
                  ))
                }
              </div>
            )
          }

          { importStatus.failed
            && (
              <div>
                <Typography
                  variant="h6"
                  component="h3"
                  color="textSecondary"
                  className={ classes.title }
                >
                  Failed
                </Typography>
                {
                  importStatus.failed.map(recipient => (
                    <Recipient key={ recipient.recipient } info={ recipient } />
                  ))
                }
              </div>
            )
          }

        </CardContent>
        <CardActions>
          <Button size="small" onClick={ close }>Close</Button>
        </CardActions>
      </Card>
    );
  }
}

ImportRecipientsStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  importRecipientsKey: PropTypes.string.isRequired,
};

export default withStyles(styles)(ImportRecipientsStatus);
